import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _18_EDUCATION:Partial<EcosystemServiceModel> ={
  id:'education',
  pos:18,
  image: "/images/ecoservices/education.jpg",
  code: ["3.1.2.2", "3.1.2.1","6.1.2.1"],
  unit:'education',
  assetType:'socialUses',
  serviceType: 'cultural',
  valuationMethods:[
    {
      id: 'travelcost',
      name:"Travel Cost",
      unit: "visitor",
      element: "Visitors",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    },
    {
      id: 'contingent',
      name:"Contingent Valuation",
      unit: "person",
      element: "Population",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    },
    {
      id: 'project',
      name:"Project Budget",
      unit: "projects",
      element: "Projects",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
